


















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface SocleBundle {
    campaign: {
        formattedWeek: string;
        startDate: string;
        endDate: string;
    };
}

@Component({ components: { SimpleText } })
export default class FormattedWeek extends Vue {
    @Prop( { default: null }) public bundle !: SocleBundle;

    public static getNeededFields(): string[] {
        return [
            "bundle.campaign.formattedWeek",
            "bundle.campaign.startDate",
            "bundle.campaign.endDate",
        ];
    }
}
